import Reveal from '../modules/Reveal'
import Helpers from '../modules/Helpers'
import XHRPromise from 'xhr-promise'

class FindAddress {
    
    search(postcode) {
        return new Promise((resolve) => {
            const xhr = new XHRPromise()

            xhr.send({
                url: '/ajax/postcode.aspx?postCode=' + postcode
            }).then((response) => {
                return (new window.DOMParser()).parseFromString(response.responseText, "text/xml")
            })
            .then((data) => {
                const results = data.getElementsByTagName('Item')
                const addresses = []
                let error = null
                if (results.length == 1 && results[0].getAttribute('error_number') !== null) {
                    error = results[0].getAttribute('message')
                }

                Array.from(results).forEach((result) => {
                    if (result.getAttribute('id') !== null) {
                        addresses.push({
                            id: result.getAttribute('id'),
                            description: result.getAttribute('description')
                        })
                    }
                })

                resolve({
                    error: error,
                    addresses: addresses
                })
            })
        })
    }

    getAddress(id) {
        return new Promise((resolve) => {
            const xhr = new XHRPromise()

            xhr.send({
                url: '/ajax/postcode.aspx?addressID=' + id
            }).then((response) => {
                return (new window.DOMParser()).parseFromString(response.responseText, "text/xml")
            })
                .then((data) => {
                    const result = data.getElementsByTagName('Item')[0]
                    const address = {
                        org: result.getAttribute('organisation_name'),
                        line1: result.getAttribute('line1'),
                        line2: result.getAttribute('line2'),
                        line3: result.getAttribute('line3'),
                        line4: result.getAttribute('line4'),
                        town: result.getAttribute('post_town'),
                        county: result.getAttribute('county'),
                        postcode: result.getAttribute('postcode')
                    }

                    resolve({
                        address: address
                    })
                })
        })
    }

    validatePostcode(postcode) {
        return /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$/.test(postcode)
    }
}


class FindAddressModal {
    constructor() {
        this.modal = document.getElementsByClassName('modal-postcode')
        this.errorEl = document.getElementsByClassName('modal-postcode__error')[0]
        this.resultsEl = document.getElementsByClassName('modal-postcode__results')[0]
        this.listeners()
    }
    
    listeners() {
        new Helpers(document.getElementsByClassName('modal-postcode__submit')).eventListener((e) => {
            e.preventDefault()
            this.search()
        })
        new Helpers(this.resultsEl).eventListener((e) => {
            this.loadAddress(e.target.getAttribute('data-id'))
        })
        new Helpers(document.getElementById('btnFindPostcode')).eventListener((e) => {
            document.getElementsByClassName('modal-postcode__search')[0].postcode.value = document.getElementById('txtFindPostcode').value
            this.search()
        })
    }

    postcode() {
        return document.getElementsByClassName('modal-postcode__search')[0].postcode.value
    }

    search() {

        if (new FindAddress().validatePostcode(this.postcode())) {
            new FindAddress().search(this.postcode()).then((results) => {
                if (results.error !== null) {
                    this.error(results.error)
                    return
                }

                if (results.addresses.length === 0) {
                    this.error("No address found for this postcode.")
                } else {
                    this.listAddresses(results.addresses)
                }
            })

        } else {
            if (this.postcode() === '') {
                this.resultsEl.setAttribute('aria-hidden', true)
                this.errorEl.setAttribute('aria-hidden', true)
            } else {
                this.error("Provided postcode is not valid.")
            }
        }
    }

    error(message) {
        this.resultsEl.setAttribute('aria-hidden', true)
        this.errorEl.setAttribute('aria-hidden', false)
        this.errorEl.innerText = message
    }

    listAddresses(addresses) {

        this.resultsEl.innerHTML = ''

        addresses.forEach((address) => {
            const li = document.createElement('li')
            li.innerText = address.description
            li.setAttribute('data-id', address.id)
            this.resultsEl.appendChild(li)
        })

        this.resultsEl.setAttribute('aria-hidden', false)
        this.errorEl.setAttribute('aria-hidden', true)


    }

    loadAddress(id) {
        new FindAddress().getAddress(id).then((result) => {
            document.querySelector('[id$=_txtAdd1]').value = (result.address.org !== null ? `${result.address.org}, ` : '') + result.address.line1
            document.querySelector('[id$=_txtAdd2]').value = result.address.line2
            document.querySelector('[id$=_txtAdd3]').value = result.address.line3
            document.querySelector('[id$=_txtTown]').value = result.address.town
            document.querySelector('[id$=_txtCounty]').value = result.address.county
            document.querySelector('[id$=_txtPostcode]').value = result.address.postcode
            if (document.querySelector('[id$=_ddlCountry]') !== null) {
                document.querySelector('[id$=_ddlCountry]').value = 'GB'
            }

            // hide modal
            new Reveal(this.modal).hide('modal--active')
            new Helpers(document.getElementsByTagName('body')).removeClass('no-scroll')
        })
    }
}

if (document.getElementsByClassName('modal-postcode').length) {
    const modalPostcode = new FindAddressModal()    
}